import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import './ChangeEmails.scss';
import { useErrorsContext } from '../../../../contexts/ErrorsContext';
import { useEffect, useState } from 'react';
import { Button, Loading, NavMenu } from '../../../../components';
import { useParametrics } from '../../../../contexts/ParametricsContext';
import { PetitionCard } from '../../../../components/petitionCard/PetitionCard';
import { createChangeEmailProcedure, getChangeEmailProcedures } from '../../../../services/procedureServices';
import { ChangeEmailCard } from './ChangeEmailCard/ChangeEmailCard';

const ChangeEmail = () => {

  const { t } = useTranslation();
  const { convocation, convocationId } = useParametrics();
  const { showError } = useErrorsContext();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [creatingNewProcedure, setCreatingNewProcedure] = useState(false);
  const [petition, setPetition] = useState(null);
  const [procedures, setProcedures] = useState(null);

  const petitionId = location?.state?.petition?.petitionId;

  const _getChangeEmail = async () => {
    try {
      setLoading(true);
      const resp = await getChangeEmailProcedures(petition.petitionId);
      setProcedures(resp);
      setLoading(false);
    } catch (e) {
      showError(e);
    }
  }

  useEffect(() => {
    if(!convocationId) return;
    if(!location?.state?.petition) {
      return history.replace('/petitions')
    }
    setPetition(location.state.petition);
  }, [convocationId]);

  useEffect(() => {
    if(petition) _getChangeEmail();
  }, [petition])

  const newProcedure = async () => {
    try {
      setCreatingNewProcedure(true);
      const {id: procedureId} = await createChangeEmailProcedure(petitionId);
      history.push(`/petitions/${petitionId}/change-email/new`, {
        changeEmail: true, procedureId, petition,
      })
    } catch(e) {
      showError(e);
    } finally {
      setLoading(false);
      setCreatingNewProcedure(false);
    }
  }

  return (
    <NavMenu>
      <div className="ChangeEmail">
        <div className="content">
          {
            loading ? (
              <div className='vh-100 d-flex justify-content-center align-items-center'>
                <Loading />
              </div>
            ) : (
              <>
                <div className="w-100 d-flex justify-content-center">
                  <div className="header">
                    <Button
                      icon="/misc/icons/arrow-left-blue.svg"
                      action={() => history.goBack()}
                      className="p-2 button-only-icon me-2"
                      a11y={t('Globals.return')}
                    />
                    <h1>{t('Petitions.ChangeEmail.title')}</h1>
                  </div>
                </div>
                <div className="petitions">
                  <PetitionCard convocationTitle={convocation?.title} petition={petition} isButton={false}/>
                </div>
                    <div className="new-procedure">
                      <Button
                          disabled={creatingNewProcedure}
                          className="buttonPrimaryLarge"
                          text={t('Petitions.ChangeEmail.ChangeEmailList.newProcedure')}
                          styles={{ backgroundColor: '#34fdfe', color: '#381940' }}
                          action={newProcedure}
                      />
                    </div>
                <div className="procedures">
                  {
                    procedures.map((procedure) => {
                      return (
                        <ChangeEmailCard
                          key={procedure.id}
                          petition={petition}
                          procedure={procedure}
                        />
                      )
                    })
                  }
                </div>
                {
                  procedures.length === 0 && (
                    <div className='no-procedures'>
                      <p>No tienes ningún procedimiento de cambio de email</p>
                    </div>
                  )
                }
              </>
            )
          }
        </div>
      </div>
    </NavMenu>
  );
}

export default ChangeEmail;